$(document).ready(function () {
	var url = new URL(window.location, 'https://chicopee.com');

	$('#form1_contact').submit(function (e) {
		e.preventDefault();
		var $theForm = $(this);
		var data = $(this).serializeArray();

		$.ajax({
			url: ajaxurl,
			type: 'POST',
			data: data,
			success: function (data) {
				var response = JSON.parse(data);

				if (response.status == 'success') {
					$theForm.hide();
					$('.form-error').html('');
					$('.enquiry-form-title').hide();
					$('.form-success').fadeIn();
					$('html, body').animate(
						{
							scrollTop: $('.form-success').offset().top - 120,
						},
						400
					);
					/* if (url.pathname.includes('/en/')) {
						cf_gtag_report_conversion(); // conversion located in _meta.php
					} */
					window.dataLayer = window.dataLayer || []
					dataLayer.push({
						'event': 'contact_form_submit',
						'formType': 'Contact us',
						'formPosition': 'Footer'
					});
				} else if (response.status == 'fail') {
					$('.form-error').fadeIn();
					$('.form-error').html('');
					$(response.errors).each(function (i, index) {
						$('.form-error').append(
							'<p style="margin-top: 20px;" class="signup-container__text grey">' +
							index +
							'</p>'
						);
					});
				}
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
		});
	});

	$('#product_sample').submit(function (e) {
		e.preventDefault();
		var $theForm = $(this);
		var data = $(this).serializeArray();

		$.ajax({
			url: $theForm.attr('action'),
			type: 'POST',
			data: data,
			success: function (data) {
				var response = JSON.parse(data);

				if (response.status == 'success') {
					$theForm.hide();
					$('.form-error').html('');
					$('.form-success').fadeIn();
					$('html, body').animate(
						{
							scrollTop: $('.form-success').offset().top - 120,
						},
						400
					);
					/* if (url.pathname.includes('/en/')) {
						ps_gtag_report_conversion(); // conversion located in _meta.php
					} */
					window.dataLayer = window.dataLayer || []
					dataLayer.push({
						'event': 'product_sample_request',
						'formType': 'Contact us',
						'formPosition': 'Footer'
					});
				} else if (response.status == 'fail') {
					$('.form-error').fadeIn();
					$('.form-error').html('');
					$(response.errors).each(function (i, index) {
						$('.form-error').append(
							'<p style="margin-top: 20px;" class="signup-container__text grey">' +
							index +
							'</p>'
						);
					});
				}
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
		});
	});

	$('#contact_j_cloth').submit(function (e) {
		e.preventDefault();
		var $theForm = $(this);
		var data = $(this).serializeArray();

		$.ajax({
			url: $theForm.attr('action'),
			type: 'POST',
			data: data,
			success: function (data) {
				var response = JSON.parse(data);

				if (response.status == 'success') {
					$theForm.hide();
					$('.form-error').html('');
					$('.form-success').fadeIn();
					window.dataLayer = window.dataLayer || []
					dataLayer.push({
						'event': 'jcloth_sample_request',
						'formType': 'Contact us',
						'formPosition': 'Footer'
					});
				} else if (response.status == 'fail') {
					$('.form-error').fadeIn();
					$('.form-error').html('');
					$(response.errors).each(function (i, index) {
						$('.form-error').append(
							'<p style="margin-top: 20px;" class="signup-container__text grey">' +
							index +
							'</p>'
						);
					});
				}
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
		});
	});

	$('#recycled-microfibre-form').submit(function (e) {
		e.preventDefault();
		var $theForm = $(this);
		var data = $(this).serializeArray();

		$.ajax({
			url: ajaxurl,
			type: 'POST',
			data: data,
			success: function (data) {
				var response = JSON.parse(data);

				if (response.status == 'success') {
					$theForm.hide();
					$('.form-error').html('');
					$('.enquiry-form-title').hide();
					$('.form-success').fadeIn();
					$('html, body').animate(
						{
							scrollTop: $('.form-success').offset().top - 120,
						},
						400
					);
					/* if (url.pathname.includes('/en/')) {
						cf_gtag_report_conversion(); // conversion located in _meta.php
					}
					window.dataLayer = window.dataLayer || []
					dataLayer.push({
						'event': 'contact_form_submit',
						'formType': 'Contact us',
						'formPosition': 'Footer'
					}); */
				} else if (response.status == 'fail') {
					$('.form-error').fadeIn();
					$('.form-error').html('');
					$(response.errors).each(function (i, index) {
						$('.form-error').append(
							'<p style="margin-top: 20px;" class="signup-container__text grey">' +
							index +
							'</p>'
						);
					});
					grecaptcha.reset();
				}
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
		});
	});
});
